import * as React from "react";
import { SVGProps } from "react";

const Tera = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 99" {...props}>
    <path d="M120.53 97.82v-.06a.56.56 0 0 0 0-.08L61.66.82 61.58.7a1.53 1.53 0 0 0-2.12-.45 1.63 1.63 0 0 0-.46.43l-.08.13Q53 10.59 47 20.32a3.39 3.39 0 0 0 0 3.87Q54.93 37.09 62.81 50a3.66 3.66 0 0 1 0 4.19C54.15 68.43 45 83.4 36.26 97.7a1.55 1.55 0 0 0 .63 2.09 1.51 1.51 0 0 0 .72.18H63a1.53 1.53 0 0 0 1.36-.81l.87-1.46L77 78.36a1.53 1.53 0 0 1 2.09-.61 1.44 1.44 0 0 1 .53.48l11.66 19L92.36 99a1.55 1.55 0 0 0 1.35.8h.71a2.16 2.16 0 0 0 .36 0h24.32a1.54 1.54 0 0 0 1.54-1.53 1.56 1.56 0 0 0-.11-.45Z" />
    <path d="m52.85 55.15.85-1.4a3 3 0 0 0 0-3.43l-5.22-8.46-6-9.67a1.53 1.53 0 0 0-2.12-.5 1.51 1.51 0 0 0-.55.57L.18 97.71a1.54 1.54 0 0 0 .63 2.08 1.42 1.42 0 0 0 .73.19h23.28a1.54 1.54 0 0 0 1.35-.8l.89-1.48a1.63 1.63 0 0 0 .11-.17l1-1.6c8.29-13.75 16.23-26.88 24.54-40.56a2 2 0 0 0 .14-.22Z" />
  </svg>
);

export default Tera;
